var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-5 py-3 orange accent-2 mb-10 d-flex align-center rounded-lg"},[_c('v-icon',{staticClass:"mr-3",attrs:{"color":"black"}},[_vm._v("warning")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }